import axios from "axios";

const BASE_URL = "https://crm-backend.monit.tech";
// const BASE_URL = "http://127.0.0.1:8000";

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

// ─── Auth ────────────────────────────────────────────────────────────────────

export const login = (credentials) =>
  api.post("/auth/login/", credentials);

export const register = (data) =>
  api.post("/auth/register/", data);

export const sendResetPasswordEmail = (data) =>
  api.post("/auth/reset-password-email/", data);

export const resetPassword = (uidb64, token, data) =>
  api.post(`/auth/reset-password/${uidb64}/${token}/`, data);

export const fetchUsers = (params) =>
  api.get("/auth/users/", { params });

export const fetchPermissions = () =>
  api.get("/auth/permissions/");

export const createPermission = (data) =>
  api.post("/auth/permissions/", data);

export const updatePermission = (id, data) =>
  api.put(`/auth/permissions/${id}/`, data);

export const deletePermission = (id) =>
  api.delete(`/auth/permissions/${id}/`);

// ─── Customers ───────────────────────────────────────────────────────────────

export const fetchCustomers = () =>
  api.get("/customers/");

export const createCustomer = (data) =>
  api.post("/customers/", data);

export const updateCustomer = (id, data) =>
  api.put(`/customers/${id}/`, data);

export const deleteCustomer = (id) =>
  api.delete(`/customers/${id}/`);

// ─── Vehicles ────────────────────────────────────────────────────────────────

export const fetchVehicles = (customerId) =>
  api.get("/vehicle/", { params: customerId ? { customerId } : undefined });

export const createVehicle = (data) =>
  api.post("/vehicle/", data);

export const updateVehicle = (id, data) =>
  api.put(`/vehicle/${id}/`, data);

export const deleteVehicle = (id) =>
  api.delete(`/vehicle/${id}/`);

// ─── Solutions / Devices ─────────────────────────────────────────────────────

export const fetchSolutions = () =>
  api.get("/solution/");

export const createSolution = (data) =>
  api.post("/solution/", data);

export const updateSolution = (id, data) =>
  api.put(`/solution/${id}/`, data);

export const deleteSolution = (id) =>
  api.delete(`/solution/${id}/`);

// ─── Sales – New Installation ─────────────────────────────────────────────────

export const fetchSalesNewInstallations = () =>
  api.get("/sales-new-installation/");

export const fetchSalesNewInstallation = (id) =>
  api.get(`/sales-new-installation/${id}/`);

export const createSalesNewInstallation = (data) =>
  api.post("/sales-new-installation/", data);

export const updateSalesNewInstallation = (id, data) =>
  api.put(`/sales-new-installation/${id}/`, data);

export const deleteSalesNewInstallation = (id) =>
  api.delete(`/sales-new-installation/${id}/`);

export const emailSalesNewInstallationPdf = (id, data) =>
  api.post(`/sales-new-installation/${id}/email-pdf/`, data);

// ─── Sales Coordinator – New Installation ─────────────────────────────────────

export const fetchSalesCoordinatorNewInstallations = () =>
  api.get("/sales-coordinator-new-installation/");

export const createSalesCoordinatorNewInstallation = (data) =>
  api.post("/sales-coordinator-new-installation/", data);

export const updateSalesCoordinatorNewInstallation = (id, data) =>
  api.put(`/sales-coordinator-new-installation/${id}/`, data);

export const deleteSalesCoordinatorNewInstallation = (id) =>
  api.delete(`/sales-coordinator-new-installation/${id}/`);

// ─── Sales Coordinator – Removal / Transfer ───────────────────────────────────

export const fetchSalesCoordinatorRemovalTransfers = () =>
  api.get("/sales-coordinator-removal-transfer/");

export const createSalesCoordinatorRemovalTransfer = (data) =>
  api.post("/sales-coordinator-removal-transfer/", data);

export const updateSalesCoordinatorRemovalTransfer = (id, data) =>
  api.put(`/sales-coordinator-removal-transfer/${id}/`, data);

export const deleteSalesCoordinatorRemovalTransfer = (id) =>
  api.delete(`/sales-coordinator-removal-transfer/${id}/`);

// ─── Sales Coordinator – Repair / Replacement ────────────────────────────────

export const fetchSalesCoordinatorRepairReplacements = () =>
  api.get("/sales-coordinator-repair-replacement/");

export const createSalesCoordinatorRepairReplacement = (data) =>
  api.post("/sales-coordinator-repair-replacement/", data);

export const updateSalesCoordinatorRepairReplacement = (id, data) =>
  api.put(`/sales-coordinator-repair-replacement/${id}/`, data);

export const deleteSalesCoordinatorRepairReplacement = (id) =>
  api.delete(`/sales-coordinator-repair-replacement/${id}/`);

// ─── Customer Support – New Installation ──────────────────────────────────────

export const fetchCustomerSupportNewInstallations = () =>
  api.get("/customer-support-new-installation/");

export const fetchCustomerSupportNewInstallation = (id) =>
  api.get(`/customer-support-new-installation/${id}/`);

export const createCustomerSupportNewInstallation = (data) =>
  api.post("/customer-support-new-installation/", data);

export const updateCustomerSupportNewInstallation = (id, data) =>
  api.put(`/customer-support-new-installation/${id}/`, data);

export const deleteCustomerSupportNewInstallation = (id) =>
  api.delete(`/customer-support-new-installation/${id}/`);

export const emailCustomerSupportNewInstallationPdf = (id, data) =>
  api.post(`/customer-support-new-installation/${id}/email-pdf/`, data);

// ─── Customer Support – Complaints ────────────────────────────────────────────

export const fetchCustomerSupportComplaints = () =>
  api.get("/customer-support-complain/");

export const fetchCustomerSupportComplaint = (id) =>
  api.get(`/customer-support-complain/${id}/`);

export const createCustomerSupportComplaint = (data) =>
  api.post("/customer-support-complain/", data);

export const updateCustomerSupportComplaint = (id, data) =>
  api.put(`/customer-support-complain/${id}/`, data);

export const deleteCustomerSupportComplaint = (id) =>
  api.delete(`/customer-support-complain/${id}/`);

export const emailCustomerSupportComplaintPdf = (id, data) =>
  api.post(`/customer-support-complain/${id}/email-pdf/`, data);

// ─── Customer Support – Removal / Transfer ────────────────────────────────────

export const fetchCustomerSupportRemovalTransfers = () =>
  api.get("/customer-support-removal-transfer/");

export const fetchCustomerSupportRemovalTransfer = (id) =>
  api.get(`/customer-support-removal-transfer/${id}/`);

export const createCustomerSupportRemovalTransfer = (data) =>
  api.post("/customer-support-removal-transfer/", data);

export const updateCustomerSupportRemovalTransfer = (id, data) =>
  api.put(`/customer-support-removal-transfer/${id}/`, data);

export const deleteCustomerSupportRemovalTransfer = (id) =>
  api.delete(`/customer-support-removal-transfer/${id}/`);

export const emailCustomerSupportRemovalTransferPdf = (id, data) =>
  api.post(`/customer-support-removal-transfer/${id}/email-pdf/`, data);

// ─── Customer Support – Repair / Replacement ──────────────────────────────────

export const fetchCustomerSupportRepairReplacements = () =>
  api.get("/customer-support-repair-replacement/");

export const fetchCustomerSupportRepairReplacement = (id) =>
  api.get(`/customer-support-repair-replacement/${id}/`);

export const createCustomerSupportRepairReplacement = (data) =>
  api.post("/customer-support-repair-replacement/", data);

export const updateCustomerSupportRepairReplacement = (id, data) =>
  api.put(`/customer-support-repair-replacement/${id}/`, data);

export const deleteCustomerSupportRepairReplacement = (id) =>
  api.delete(`/customer-support-repair-replacement/${id}/`);

export const emailCustomerSupportRepairReplacementPdf = (id, data) =>
  api.post(`/customer-support-repair-replacement/${id}/email-pdf/`, data);

// ─── Technical – New Installation ─────────────────────────────────────────────

export const fetchTechnicalNewInstallations = () =>
  api.get("/technical-new-installation/");

export const fetchTechnicalNewInstallation = (id) =>
  api.get(`/technical-new-installation/${id}/`);

export const updateTechnicalNewInstallation = (id, data) =>
  api.put(`/technical-new-installation/${id}/`, data);

export const emailTechnicalNewInstallationPdf = (id, data) =>
  api.post(`/technical/${id}/email-pdf/`, data);

// ─── Technical – Complaints ───────────────────────────────────────────────────

export const fetchTechnicalComplaints = () =>
  api.get("/technical-complaint/");

export const fetchTechnicalComplaint = (id) =>
  api.get(`/technical-complaint/${id}/`);

export const updateTechnicalComplaint = (id, data) =>
  api.put(`/technical-complaint/${id}/`, data);

export const emailTechnicalComplaintPdf = (id, data) =>
  api.post(`/technical-complaint/${id}/email-pdf/`, data);

// ─── Technical – Removal / Transfer ───────────────────────────────────────────

export const fetchTechnicalRemovalTransfers = () =>
  api.get("/technical-removal-transfer/");

export const fetchTechnicalRemovalTransfer = (id) =>
  api.get(`/technical-removal-transfer/${id}/`);

export const updateTechnicalRemovalTransfer = (id, data) =>
  api.put(`/technical-removal-transfer/${id}/`, data);

export const emailTechnicalRemovalTransferPdf = (id, data) =>
  api.post(`/technical-removal-transfer/${id}/email-pdf/`, data);

// ─── Technical – Repair / Replacement ────────────────────────────────────────

export const fetchTechnicalRepairReplacements = () =>
  api.get("/technical-repair-replacement/");

export const fetchTechnicalRepairReplacement = (id) =>
  api.get(`/technical-repair-replacement/${id}/`);

export const updateTechnicalRepairReplacement = (id, data) =>
  api.put(`/technical-repair-replacement/${id}/`, data);

export const emailTechnicalRepairReplacementPdf = (id, data) =>
  api.post(`/technical-repair-replacement/${id}/email-pdf/`, data);

// ─── Production – New Installation ────────────────────────────────────────────

export const fetchProductionNewInstallations = () =>
  api.get("/production-new-installation/");

export const fetchProductionNewInstallation = (id) =>
  api.get(`/production-new-installation/${id}/`);

export const updateProductionNewInstallation = (id, data) =>
  api.put(`/production-new-installation/${id}/`, data);

export const emailProductionNewInstallationPdf = (id, data) =>
  api.post(`/production-new-installation/${id}/email-pdf/`, data);

// ─── Production – Repair / Replacement ───────────────────────────────────────

export const fetchProductionRepairReplacements = () =>
  api.get("/production-repair-replacement/");

export const fetchProductionRepairReplacement = (id) =>
  api.get(`/production-repair-replacement/${id}/`);

export const updateProductionRepairReplacement = (id, data) =>
  api.put(`/production-repair-replacement/${id}/`, data);

export const emailProductionRepairReplacementPdf = (id, data) =>
  api.post(`/production-repair-replacement/${id}/email-pdf/`, data);

// ─── Dispatch (Store) – New Installation ──────────────────────────────────────

export const fetchDispatchNewInstallations = () =>
  api.get("/dispatch-new-installation/");

export const updateDispatchNewInstallation = (id, data) =>
  api.put(`/dispatch-new-installation/${id}/`, data);

export const emailDispatchNewInstallationPdf = (id, data) =>
  api.post(`/dispatch-new-installation/${id}/email-pdf/`, data);

export const generateDispatchNewInstallationPdf = (id) =>
  api.post(`/dispatch-new-installation/${id}/generate-pdf/`);

// ─── Dispatch (Store) – Repair / Replacement ─────────────────────────────────

export const fetchDispatchRepairReplacements = () =>
  api.get("/dispatch-repair-replacement/");

export const updateDispatchRepairReplacement = (id, data) =>
  api.put(`/dispatch-repair-replacement/${id}/`, data);

export const emailDispatchRepairReplacementPdf = (id, data) =>
  api.post(`/dispatch-repair-replacement/${id}/email-pdf/`, data);

export const generateDispatchRepairReplacementPdf = (id) =>
  api.post(`/dispatch-repair-replacement/${id}/generate-pdf/`);

// ─── Installation History ─────────────────────────────────────────────────────

export const fetchInstallationHistories = () =>
  api.get("/installation-history/");

export const fetchInstallationHistory = (id) =>
  api.get(`/installation-history/${id}/`);

export const updateInstallationHistory = (id, data) =>
  api.put(`/installation-history/${id}/`, data);

export const emailInstallationHistoryPdf = (id, data) =>
  api.post(`/installation-history/${id}/email-pdf/`, data);

// ─── Removal/Transfer History ─────────────────────────────────────────────────

export const fetchRemovalTransferHistories = () =>
  api.get("/removal-transfer-history/");

export const fetchRemovalTransferHistory = (id) =>
  api.get(`/removal-transfer-history/${id}/`);

export const updateRemovalTransferHistory = (id, data) =>
  api.put(`/removal-transfer-history/${id}/`, data);

// ─── Repair/Replacement History ───────────────────────────────────────────────

export const fetchRepairReplacementHistories = () =>
  api.get("/repair-replacement-history/");

export const fetchRepairReplacementHistory = (id) =>
  api.get(`/repair-replacement-history/${id}/`);

export const updateRepairReplacementHistory = (id, data) =>
  api.put(`/repair-replacement-history/${id}/`, data);

// ─── Utilities ────────────────────────────────────────────────────────────────

export const fetchCounts = () =>
  api.get("/counts/");

export const fetchDeviceHistory = (params) =>
  api.get("/device-history/", { params });

export const fetchImeiAttach = (params) =>
  api.get("/imei-attach/", { params });

// ─── Bulk Uploads ─────────────────────────────────────────────────────────────

export const bulkUploadCustomers = (formData) =>
  api.post("/upload-customers/", formData);

export const bulkUploadSolutions = (formData) =>
  api.post("/upload-solution/", formData);

export const bulkUploadSales = (formData) =>
  api.post("/upload-sales/", formData);

export const bulkUploadVehicles = (formData) =>
  api.post("/upload-vehicles/", formData);

export const bulkUploadOperations = (formData) =>
  api.post("/upload-operations/", formData);

export const bulkUploadAttachments = (formData) =>
  api.post("/upload-attachments/", formData);

export default api;
